<template>
  <button
    type="button"
    class="relative flex w-fit flex-row items-center justify-center gap-x-3 overflow-hidden rounded-md px-6 py-2 text-base font-semibold leading-5"
    :class="[baseClasses, $attrs.class]"
    @click="handleClickButtonCommon"
  >
    <slot />
    <span>{{ text }}</span>
  </button>
</template>

<script setup lang="ts">
import type { TButtonVariants } from '~/src/types/common'
import { useButtonClassesAndEvent } from '~/composables/useButtonClassesAndEvent'

const props = withDefaults(
  defineProps<{
    eventId?: string
    text?: string
    variant?: TButtonVariants
  }>(),
  {
    eventId: 'common',
    text: 'Button',
    variant: 'primary',
  },
)

const { baseClasses, handleClickButtonCommon } = useButtonClassesAndEvent(
  props.variant,
  props.eventId,
)
</script>
